import React from 'react';
import Blocks from './Blocks';
import { IPageFields } from '@/types/contentful';

export function AltHeroBlock({ altHeroBlock }: IPageFields) {
  const { sys, fields } = altHeroBlock ?? {};

  return <Blocks sys={sys} fields={fields} />;
}
